import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { SatHachs_DanhSachThi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-ngayhethanedit',
  templateUrl: './ngayhethanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./ngayhethanedit.component.scss'],
    providers: [ListService, Repository]
})


export class ngayhethaneditComponent implements OnInit {

   
  public ngayhethan: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, SoBaoDanh: null, HoVaTen: null, NgaySinh: null, SoCMND: null, NgayCap: null, NoiCap: null
    , TenDonVi: null, Email: null, NgayHetHan: null
    , PhanHeId: null, Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
  };    
    nhomdtid:string=null;
    hoatdong:string=null;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slNhomCTMT', { static: false }) slNhomCTMT: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
    //  this.bnguonkinhphi = true;

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_cmmt.id.toLocaleLowerCase())
    //  this.bnhomctmt = true;

    //if (nhomdoituongid.toLocaleUpperCase() == "5E79BF59-78D9-4C54-8EF7-0A242F5CBC24")
    //  this.hoatdong = "Ngừng theo dõi"
    //else
      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].Them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].Sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].Xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/'+id+'/'+donviid)
        //.subscribe(response => {            
        //    this.inputparents=response;
        //});
   

    this.doituongSelect = {
      Id: null, SoBaoDanh: null, HoVaTen: null, NgaySinh: null, SoCMND: null, NgayCap: null, NoiCap: null
      , TenDonVi: null, Email: null, NgayHetHan: null
      , PhanHeId: null, Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };
    this.ngayhethan = null;

    this.doituongSelect.SoBaoDanh = id;
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.SoBaoDanh == null || this.doituongSelect.SoBaoDanh == "") {
      swal('Lỗi!', 'Vui lòng chọn danh sách cán bộ trước khi thiết lập ngày hết hạn!.', 'error');
      return;
    }

    if (this.ngayhethan != null)
      this.doituongSelect.NgayHetHanS = this.ngayhethan.getFullYear() + '-' + (this.ngayhethan.getMonth() + 1) + '-' + this.ngayhethan.getDate()
        + ' ' + this.ngayhethan.getHours() + ':' + this.ngayhethan.getMinutes()
        + ':' + this.ngayhethan.getSeconds();
    else {
      swal('Lỗi!', 'Vui lòng nhập ngày hết hạn!.', 'error');
      return;
    }
    
    this.repo.postRequest("api/danhsachthi/thietlapngayhethan", { GhiChu: this.doituongSelect.SoBaoDanh, NgayHetHanS: this.doituongSelect.NgayHetHanS })
            .subscribe(response => {  
              //if (response != null && response.match('-')) {
                this.save.emit(this.doituongSelect);
              //}
              //else {
              //  swal('Lỗi!', response, 'error');
              //}
            }); 
    }
   
    
   

   


}
